<template>
  <ManagementPage :pageName="$tc('ImportNoun',1) + ' / ' + $tc('Layer',2)" grid>
    <template v-slot:top-left>
      <imports-form
        ref="importsForm"
        :layers="layers"
        :layer-options="layerOptions"
        :loading="loading" 
        @submit-form="createImport"
        @submit-external-form="createExternalImport"
      />
    </template>

    <template v-slot:bottom-left>
      <Imports-map />
    </template>

    <template v-slot:top-right>
      <table-view-submitted-files @set-import-obj="setImportObj" @validate="handleValidate" ref="importsTable" @clear-conflicts-table="clearConflictsTable"/>
    </template>

    <template v-slot:bottom-right>
      <table-view-conflicts :import-obj="importObj" @clear-selected-import="importObj={}" @refresh-imports-table="refreshImportsTable" :layers="layers" ref="conflictsTable"/>
    </template>
  </ManagementPage>
</template>
  
<script>
  import ManagementPage from "@/newComponents/_Organisms/ManagementPage.vue";
  import { mapActions } from "vuex";
  import { bus } from "@/main.js";
  import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
  import ImportsForm from "@/newComponents/Data/Imports/ImportsForm.vue";
  import TableViewSubmittedFiles from "../newComponents/Data/Imports/TableViewSubmittedFiles.vue";
  import TableViewConflicts from "../newComponents/Data/Imports/TableViewConflicts.vue";
  import ImportsMap from "../newComponents/Data/Imports/ImportsMap.vue";
  import LoadingSpinner from "vue-loading-overlay";
  import { importMixin } from "@/mixins/management/importMixin";
  
  export default {
    name: "ImportsView",
  
    props: ["pageName", "menu"],
  
    components: {
      ManagementPage,
      ImportsForm,
      ImportsMap,
      TableViewSubmittedFiles,
      TableViewConflicts,
      LoadingSpinner
    },
  
    mixins: [checkPermissionsMixin, importMixin],
  
    data() {
      return {
        loading: false,
        layerOptions: [],
        importObj:{}
      }
    },

    mounted() {
      this.getAllLayersInfo();
    },
  
    methods: {
      ...mapActions(["CREATE_IMPORT_VALIDATION", "FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS","createNewImport"]),

      refreshImportsTable(){
        this.$refs.importsTable.getInitialImports();
      },

      clearConflictsTable(){
        this.$refs.conflictsTable.clearTable();
      },

      async getAllLayersInfo() {
        try {
          let objectProperties = this.$store.getters.getAllObjectTypesProperties;
          if (objectProperties.length === 0) {
            await this.FETCH_ALL_OBJECTS_PROPERTIES_WITHOUT_FIELDS();
          }
          this.updateLayersInfo();
        } catch (error) {
          console.log(error);
        }
      },
  
      updateLayersInfo() {
        this.layers.forEach((layer) => {
  
          layer.endpoint = this.$store.getters.getLayerEndpoint(layer.layer);
          layer.permissionName = this.$store.getters.getLayerPermissionName(
            layer.layer,
          );
          layer.label = this.getLayerName(layer.layer);
          layer.initials = this.$store.getters.getLayerInitials(layer.layer);
          layer.idField = layer.initials + '_id';
          layer.uuidField = layer.initials + '_uuid';
          if (!layer.hasOwnProperty('labelField')) {
            layer.labelField = layer.initials + '_label'
          }
          layer.creationDateField = layer.initials + '_created_at';
          layer.updateDateField = layer.initials + '_updated_at';
        })
        let arr = [];
        let numberOfPossibleLayers = this.layers.length;
        for (let i = 0; i < numberOfPossibleLayers; i++) {
          let layer = this.layers[i];
          arr.push({
            id: layer.layer,
            label: layer.label,
          });
        }
        this.layerOptions = [...arr];
      },

      /**
       * Get's the name to exhibit on the layer option label.
       * @param {String} layer - layer being analysed
       * @returns {String}
       */
       getLayerName(layer) {
        let label = this.$store.getters.getLayerTranslationKey(layer);
        return this.$i18n.tc(label, 2);
      },

      handleValidate(obj){
        const layerObj = this.getObjectProperties(obj);
        this.importObj = {...obj, endpoint: layerObj.endpoint};
        this.$nextTick(() => this.$refs.conflictsTable.handleValidate());
      },

      setImportObj(obj){
        if(obj.id === this.importObj.id){
          this.$refs.conflictsTable.handleSameRowClick();
          return;
        }
        const layerObj = this.getObjectProperties(obj);
        this.importObj = {...obj, endpoint: layerObj.endpoint};
      },

      /**
       * Imports the features in the input file, adds it to the map and centers it on the feature
       */
       async createImport({endpoint, data}) {
        this.loading = true;
        try{
          await this.CREATE_IMPORT_VALIDATION({
            endpoint,
            data
          });
          this.$refs.importsTable.getInitialImports();
          this.$refs.importsForm.resetForm();
        }catch(error){
          console.log(error);
          this.$toasted.global.toast_error(error.response.data.message);
        }finally{
          this.loading = false;
        }
      },

      async createExternalImport(data) {
        this.loading = true;
        try{
          await this.createNewImport(data);
          this.$refs.importsTable.getInitialImports();
          this.$refs.importsForm.resetForm();
        }catch(error){
          console.log(error);
          this.$toasted.global.toast_error(error.response.data.message);
        }finally{
          this.loading = false;
        }
      },

      getObjectProperties(importObj) {
        let layerName = importObj.filteredType;

        let layerData = this.layers.find(item => item.layer === layerName);

        const layerProperties = {
          endpoint: layerData.endpoint
        };

        return layerProperties;
      },
    },
  };
</script>
  
<style scoped>
  .main-container {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #fafbfc;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  
  .searchContainer {
    display: flex;
    align-items: center;
  }
  
  .temporatyLeft {
    width: 66%;
    height: 100%;
  }
  
  .tabs-custom {
    display: flex;
    flex-direction: column;
    justify-content: flex-start !important;
  }
  
  .span-custom {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 4px 20px 4px 20px;
    color: #767676;
    font-family: Lato;
    font-size: 0.625rem;
    font-style: normal;
    font-weight: 400;
    line-height: 0.9375rem; /* 150% */
  }
  
  .buttons-container-custom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  
  .cancel-button-custom {
    background: transparent;
    border-radius: 0.25rem;
    border: 0.609px solid var(--app-primary-base);
  }
  .leftCardContainer {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 3.25104px 3.25104px 0px rgba(0, 0, 0, 0.25);
    padding: 20px 28px;
  }
  
  .actionsContainer {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  
  .leftTitle {
    color: #767676;
    font-family: Lato;
    font-size: 10px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px; /* 200% */
    text-transform: uppercase;
  }
  
  .rightSideTitleActions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  
  .layer-search {
    flex: 0 0 auto;
    font-size: 12px;
    margin-right: 5px;
  }
  
  .layers-search .v-input__slot {
    min-height: 0 !important;
  }
  
  .layers-search .v-label {
    top: 4px !important;
    font: normal normal normal 12px/16px Segoe UI;
    color: #b1b6b9;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/ImportsView.vue